<template>
  <div class="little-tip">
    <div class="tip-header">
      <div class="header-title">
        小提示
      </div>
      <div class="header-icon">
        <span :class="openStatus === 'open' ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="handleOpen"></span>
      </div>
    </div>
    <div v-if="openStatus === 'open'" class="tip-container">
      <div class="container-row" v-for="(tip,tipIndex) in detailData.tips" :key="tipIndex">
        <el-image class="tip-icon" :src="require('../../../assets/consultingRoom/tip_icon.png')"></el-image>
        <div class="tip-text">
          {{tip}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    detailData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      openStatus: 'open'
    }
  },
  mounted() {
    if(localStorage.getItem('consulting_room_tip_status')) {
      this.openStatus = localStorage.getItem('consulting_room_tip_status')
    }
  },
  methods: {
    handleOpen() {
      this.openStatus = this.openStatus === 'open' ? 'close' : 'open'
      localStorage.setItem('consulting_room_tip_status',this.openStatus)
    }
  }
}
</script>
<style>
.little-tip{
  margin-top: 32px;
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 24px 32px;
  user-select: none;
  .tip-header{
    display: flex;
    .header-title{
      flex: 1;
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      font-size: 20px;
      color: #333333;
    }
    .header-icon{
      font-size: 16px;
      span{
        cursor: pointer;
      }
    }
  }
  .tip-container{
    padding-top: 24px;
    .container-row{
      display: flex;
      gap: 12px;
      margin-bottom: 12px;
      .tip-icon{
        width: 24px;
        height: 24px;
      }
      .tip-text{
        font-family: PingFang HK, PingFang HK;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        cursor: default;
      }
    }
    .container-row:last-child{
      margin-bottom: 0px;
    }
  }
}
</style>
